import { Result } from "@cartographerio/fp";
import { isPoint, safePointToNgr, } from "@cartographerio/geometry";
import { hasOptionalKey, isNullable, isObject, isString, } from "@cartographerio/guard";
import { isTimestamp } from "@cartographerio/types";
export function isPartialData(data) {
    return (isObject(data) &&
        hasOptionalKey(data, "recorded", isNullable(isTimestamp)) &&
        hasOptionalKey(data, "location", isNullable(isPoint)) &&
        hasOptionalKey(data, "siteName", isNullable(isString)));
}
function createDescription(...args) {
    return args.filter(arg => arg != null).join(", ");
}
const g = Result.guard(isPartialData, "PartialWrtFordsData");
export function dataDescription(data) {
    return g(data).map(data => createDescription(data.siteName ?? "Unknown site", data.location ? safePointToNgr(data.location) : "Unknown NGR"));
}
export function dataGeometry(data) {
    return g(data).map(data => data.location ?? null);
}
export function dataTimestamp(data) {
    return g(data).map(data => data.recorded ?? null);
}
//# sourceMappingURL=parts.js.map